import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';
import Select from './filters/Select';

const Filters = () => {
    const settings = useSettingsContext();
    const { tax, selectTaxTerm } = useFiltersContext();

    const taxEntries = Object.entries(tax);

    if ( settings.showFilters && taxEntries.length ) {

        return (
            <div className="pfa-filters">
                {taxEntries.map(([key, taxonomy]) => {
                    return <Select taxonomy={ taxonomy } key={ key } />
                })}
            </div>
        )
    }

    return '';
}

Filters.displayName = 'Filters';

export default Filters;